import { useEffect, useState } from 'react';
import { SOURCES, ACTIONS } from 'constants/preview';

const usePreviewMode = () => {
  const [data, setData] = useState(null);
  const [origin, setOrigin] = useState('');
  const [isPreview, setIsPreview] = useState(false);

  const handleEventMessage = (event, callback) => {
    const { data, origin: eventOrigin } = event;

    const originHostname = new URL(eventOrigin).hostname;

    if (
      originHostname !== window.location.hostname ||
      data.source !== SOURCES.CMS_APPLICATION
    ) {
      return;
    }

    callback(data.context);
  };

  const sendMessageToParent = (origin, action, context) => {
    window.parent.postMessage(
      {
        source: SOURCES.PREVIEW_APPLICATION,
        action,
        context
      },
      origin
    );
  };

  useEffect(() => {
    const searchParams = new URLSearchParams(window.location.search);

    setOrigin(searchParams.get('origin'));
    setIsPreview(searchParams.has('brandPreview'));
  }, []);

  useEffect(() => {
    const eventHandler = event => handleEventMessage(event, setData);

    if (origin) {
      window.addEventListener('message', eventHandler);
      sendMessageToParent(origin, ACTIONS.PREVIEW_LOADED);
    }

    return () => window.removeEventListener('message', eventHandler);
  }, [origin]);

  return {
    data,
    isPreview
  };
};

export default usePreviewMode;
